export default {
  apiUrl: 'http://yoursite.com/api/',
};

const siteLogo = require('./images/icons/logobranco.png');
const siteTitle = require('./images/icons/tituloBranco.png');

const siteConfig = {
  siteName: 'MEAGENDA',
  siteIcon: 'ion-flash',
  footerText: `MEAGENDA ${process.env.REACT_APP_VERSION} ©${new Date().getFullYear()}`,
  siteLogo,
  siteTitle,
  appVersion: process.env.REACT_APP_VERSION,
  supportEmail: 'contato@meagenda.com.br',
  supportWhatsApp: '5544998944788',
  professionalSiteUrl: 'https://profissionais.meagenda.com.br',
  instagramUrl: 'https://www.instagram.com/meagenda/?hl=pt-br',
  facebookUrl: 'https://www.facebook.com/meagenda/?ref=br_rs',
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};
const language = 'portuguese';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  authDomain: process.env.REACT_APP_FIREBASE_CUSTOM_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const googleConfig = {
  apiKey: process.env.REACT_APP_GOOGLE_API,
  // Advanced markers exigem um Map ID; DEMO_MAP_ID serve apenas em desenvolvimento.
  mapId: process.env.REACT_APP_GOOGLE_MAP_ID || 'DEMO_MAP_ID',
};

const jwtConfig = {
  fetchUrl: '/api/',
  secretKey: 'secretKey',
};

// URLs do selo "Serviços Financeiros Asaas" hospedadas no CDN do Asaas.
// Links homologados pelo Asaas — não hospedar cópia local nem alterar o SVG.
const asaasSealConfig = {
  urlPositive: 'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Positivo.svg?id=ed19dd6a-29c1-40ce-8fe3-683aa4d54094',
  urlNegativeBlack: 'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Negativo-Preto.svg?id=ed19dd6a-29c1-40ce-8fe3-683aa4d54094',
  urlNegativeWhite: 'https://baas.asaas.com/selos/Servicos_financeiros_Asaas-Reduzida-Negativo-Branco.svg?id=ed19dd6a-29c1-40ce-8fe3-683aa4d54094',
  siteUrl: 'https://asaas.com',
};

export {
  siteConfig,
  language,
  themeConfig,
  firebaseConfig,
  googleConfig,
  jwtConfig,
  asaasSealConfig,
};
